import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner,
} from "reactstrap";
import { toast } from "react-toastify";

import { StaticFilterSelect } from "components/Common/AsyncSearchSelects";
import {
    downloadMonthSummaryReport,
    fetchMonthSummaryYearOptions,
} from "model/MonthWiseSummaryReportModel";

const MonthWiseSummaryReport = () => {
    const [yearOptions, setYearOptions] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [loadingYears, setLoadingYears] = useState(false);
    const [downloading, setDownloading] = useState(false);

    useEffect(() => {
        const loadYearOptions = async () => {
            setLoadingYears(true);
            try {
                const options = await fetchMonthSummaryYearOptions();
                const normalizedOptions = Array.isArray(options) ? options : [];
                setYearOptions(normalizedOptions);

                const currentYear = String(new Date().getFullYear());
                const defaultYear =
                    normalizedOptions.find(
                        (option) => String(option?.value) === currentYear
                    )?.value ?? normalizedOptions[0]?.value ?? "";
                setSelectedYear(defaultYear ? String(defaultYear) : "");
            } finally {
                setLoadingYears(false);
            }
        };

        void loadYearOptions();
    }, []);

    const handleYearChange = (option) => {
        setSelectedYear(option?.value ? String(option.value) : "");
    };

    const handleDownload = async () => {
        const year = Number(selectedYear);
        if (!Number.isFinite(year) || year <= 0) {
            toast.error("Please select a year");
            return;
        }

        setDownloading(true);
        try {
            const downloaded = await downloadMonthSummaryReport(year);
            if (downloaded) {
                toast.success("Month summary report downloaded");
            }
        } finally {
            setDownloading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content month-wise-summary-report-page">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <h5 className="fw-bold mb-3">Month Wise Summary Report</h5>
                            <hr />

                            <div className="upper-filter-bar manage-user-filter-strip w-100">
                                <Row className="g-2 g-md-3 align-items-end">
                                    <Col xs="12" md="6" lg={4}>
                                        <span className="manage-user-filter-label">Select Year</span>
                                        <StaticFilterSelect
                                            options={yearOptions}
                                            placeholder="Select Year"
                                            value={selectedYear}
                                            onChange={handleYearChange}
                                            isClearable={false}
                                            isDisabled={loadingYears}
                                            isSearchable
                                        />
                                    </Col>
                                    <Col xs="12" md="6" lg={3}>
                                        <span
                                            className="manage-user-filter-label"
                                            aria-hidden="true"
                                        >
                                            &nbsp;
                                        </span>
                                        <Button
                                            color="primary"
                                            className="w-100 manage-user-search-btn"
                                            type="button"
                                            onClick={handleDownload}
                                            disabled={downloading || loadingYears || !selectedYear}
                                        >
                                            {downloading ? (
                                                <>
                                                    <Spinner size="sm" className="me-1" />
                                                    Downloading…
                                                </>
                                            ) : (
                                                <>
                                                    <i
                                                        className="bx bx-download me-1"
                                                        aria-hidden="true"
                                                    />
                                                    Download
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

MonthWiseSummaryReport.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(MonthWiseSummaryReport);
